import { styled } from '@mui/material'
import Typography from '@mui/material/Typography'
import { COLORS } from '../../styles/colors'

export const TypographyHeaderSecondary = styled(Typography)(theme => ({
	fontWeight: 700,
	fontSize: '16px',
	lineHeight: '20px',
	color: COLORS.black,
}))
